<div *ngIf="remarks && remarks.length" class="data-list">
  <app-data-item *ngFor="let remark of remarks" [source]="remark.sourceId" [compact]="compact"
                 [showLabel]="!compact" [linkify]="linkify">
    {{ remark.text }}
  </app-data-item>
</div>
